<template>
  <v-bottom-sheet v-model="stShowNotes" hide-overlay>
      <v-sheet class="text-right">
        <v-btn 
          icon
          color="primary"
          class="btn-close"
          @click="showNotes"
        >
          <v-icon class="font-size-32 white rounded-circle"> mdi-close-circle</v-icon>
        </v-btn>
        <StickyNotes @close-note="showNotes" />
      </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import StickyNotes from './bookUtils/StickyNotes.vue'

export default {
  components: {
    StickyNotes,
  },
  methods: {
    ...mapActions('bookReading', [
      'showNotes',
    ]),
  },
  computed: {
    ...mapState({
      stShowNotes: (state) => state.bookReading.mobileTools.showNotes,
    })
  }
}
</script>

<style lang="scss">

.v-bottom-sheet{
  position: relative;
  .btn-close{
    position: absolute;
    right: 24px;
    left: inherit;
    top: 1em;
    z-index: 10;
  }
}


</style>